import {call, put, select} from 'redux-saga/effects'
import {State} from '../../ducks'
import {CityDTO} from 'grilnica-share'
import {ClientDTO, PushClientDTO} from 'grilnica-store-share'
import {PushActions} from '../duck'
import {
  hidePushMessageService,
  loadPushMessagesService,
  readPushMessageService,
} from '../../../services/push'

function* initializePush() {
  try {
    const client: ClientDTO = yield select((state: State) => state.auth.client)
    if (client) {
      yield call(loadPushMessages)
    }
  } catch (error) {
    console.info('initializePush error: ', error)
  }
}

function* loadPushMessages() {
  const city: CityDTO = yield select((state: State) => state.city.selectedCity)
  try {
    const messages: PushClientDTO[] = yield call(loadPushMessagesService, city.cityId)
    yield put(PushActions.setPushMessages(messages))
  } catch (e) {
    console.error('loadPushMessages error', e)
  }
}

function* readPushMessage({payload}: any) {
  const {pushQueueId} = payload
  const city: CityDTO = yield select((state: State) => state.city.selectedCity)
  try {
    yield call(readPushMessageService, pushQueueId, city.cityId)
    yield put(PushActions.readMessageSuccess(pushQueueId))
    yield call(loadPushMessages)
  } catch (e) {
    console.error('readPushMessage error', e)
  }
}

function* hidePushMessage({payload}: any) {
  const {pushQueueId} = payload
  const city: CityDTO = yield select((state: State) => state.city.selectedCity)
  try {
    yield call(hidePushMessageService, pushQueueId, city.cityId)
    yield put(PushActions.hidePushMessageSuccess(pushQueueId))
    yield call(loadPushMessages)
  } catch (e) {
    console.error('hidePushMessage error', e)
  }
}

export {initializePush, readPushMessage, hidePushMessage}
